module.exports = __webpack_public_path__ + "static/media/en-GB.eec5df3d.png";